export default __webpack_public_path__ + "static/media/Group1627@2x.db06ad6e.png";